export default __webpack_public_path__ + "static/051-434d4f1208e751c38e17e75acfec1505.jpg";